import { render, staticRenderFns } from "./SiaAreas.vue?vue&type=template&id=228031c7&scoped=true"
import script from "./SiaAreas.vue?vue&type=script&lang=js"
export * from "./SiaAreas.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "228031c7",
  null
  
)

export default component.exports